"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityRequestAbbrDto = instanceOfOrientationOpportunityRequestAbbrDto;
exports.OrientationOpportunityRequestAbbrDtoFromJSON = OrientationOpportunityRequestAbbrDtoFromJSON;
exports.OrientationOpportunityRequestAbbrDtoFromJSONTyped = OrientationOpportunityRequestAbbrDtoFromJSONTyped;
exports.OrientationOpportunityRequestAbbrDtoToJSON = OrientationOpportunityRequestAbbrDtoToJSON;
exports.OrientationOpportunityRequestAbbrDtoToJSONTyped = OrientationOpportunityRequestAbbrDtoToJSONTyped;
const OrientationOpportunityRequestStatus_1 = require("./OrientationOpportunityRequestStatus");
const RequestedBy_1 = require("./RequestedBy");
/**
 * Check if a given object implements the OrientationOpportunityRequestAbbrDto interface.
 */
function instanceOfOrientationOpportunityRequestAbbrDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('requestedBy' in value) || value['requestedBy'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityRequestAbbrDtoFromJSON(json) {
    return OrientationOpportunityRequestAbbrDtoFromJSONTyped(json, false);
}
function OrientationOpportunityRequestAbbrDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': (0, OrientationOpportunityRequestStatus_1.OrientationOpportunityRequestStatusFromJSON)(json['status']),
        'requestedBy': (0, RequestedBy_1.RequestedByFromJSON)(json['requestedBy']),
        'message': json['message'] == null ? undefined : json['message'],
        'declineReason': json['declineReason'] == null ? undefined : json['declineReason'],
        'declinedAt': json['declinedAt'] == null ? undefined : (new Date(json['declinedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function OrientationOpportunityRequestAbbrDtoToJSON(json) {
    return OrientationOpportunityRequestAbbrDtoToJSONTyped(json, false);
}
function OrientationOpportunityRequestAbbrDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': (0, OrientationOpportunityRequestStatus_1.OrientationOpportunityRequestStatusToJSON)(value['status']),
        'requestedBy': (0, RequestedBy_1.RequestedByToJSON)(value['requestedBy']),
        'message': value['message'],
        'declineReason': value['declineReason'],
        'declinedAt': value['declinedAt'] == null ? undefined : (value['declinedAt'].toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}
//# sourceMappingURL=OrientationOpportunityRequestAbbrDto.js.map